import { defineStore } from 'pinia'
import { useAccountStore } from '@/stores/account'

function getApiBase(): string {
  if (import.meta.dev) return '/_api'
  const config = useRuntimeConfig()
  return (config.public.NUXT_APP_LANDING_API as string) || 'https://v2-api.bibleawr.com'
}

export const useGoogleAuthStore = defineStore('googleAuth', () => {
  const url = ref<string | null>(null)

  async function fetchUrl() {
    if (url.value) return
    try {
      const redirect = '/my/progress'
      const accountStore = useAccountStore()
      const accountId = accountStore.account?._id ?? undefined

      const params = new URLSearchParams({ redirect })
      if (accountId) params.set('accountId', accountId)

      const res = await fetch(`${getApiBase()}/my/auth/google/url?${params.toString()}`)
      if (!res.ok) return
      const data = await res.json()
      url.value = data?.url ?? data?.data?.url ?? null
    } catch { /* Google OAuth not configured */ }
  }

  return { url, fetchUrl }
})
